import axiox from './axios';
import {SET_USERS,SET_USERS_LOADING,GET_ERRORS} from './types'

export const getUsers = () => dispatch => {
  dispatch(setUsersLoading());
  axiox
    .get('/api/users/users')
    .then(res =>
      dispatch({
        type: SET_USERS,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const setUsersLoading = () => {
  return {
    type: SET_USERS_LOADING
  };
};


// WEBPACK FOOTER //
// ./src/actions/userAction.js